import StatBoxSimple from "./StatBoxSimple";

export default StatBoxSimple